import CommonSettings from './CommonSettings'

const SOCIAL_NETWORKS = [
  { name: 'facebook', label: 'Facebook' },
  { name: 'twitter', label: 'X (Twitter)' },
  { name: 'instagram', label: 'Instagram' },
  { name: 'linkedin', label: 'LinkedIn' },
  { name: 'youtube', label: 'YouTube' },
  { name: 'tiktok', label: 'TikTok' },
  { name: 'pinterest', label: 'Pinterest' },
  { name: 'github', label: 'GitHub' }
]

export default function SocialSettings({ block, onUpdate }) {
  const { settings } = block

  const updateNetwork = (index, field, value) => {
    const updated = [...(settings.networks || [])]
    updated[index] = { ...updated[index], [field]: value }
    onUpdate({ networks: updated })
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <h4 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>Social Networks</h4>

      {(settings.networks || []).map((network, idx) => {
        const info = SOCIAL_NETWORKS.find(s => s.name === network.name) || { label: network.name }
        return (
          <div key={idx} style={{
            padding: '0.75rem',
            background: network.enabled ? '#f8fafc' : '#fafafa',
            borderRadius: '8px',
            border: `1px solid ${network.enabled ? '#e2e8f0' : '#f1f5f9'}`,
            opacity: network.enabled ? 1 : 0.6
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: network.enabled ? '0.5rem' : 0 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', flex: 1 }}>
                <input
                  type="checkbox"
                  checked={network.enabled}
                  onChange={(e) => updateNetwork(idx, 'enabled', e.target.checked)}
                  style={{ cursor: 'pointer' }}
                />
                <span style={{ fontSize: '0.85rem', fontWeight: '500' }}>{info.label}</span>
              </label>
            </div>
            {network.enabled && (
              <input
                type="text"
                value={network.url || ''}
                onChange={(e) => updateNetwork(idx, 'url', e.target.value)}
                placeholder={`https://${network.name}.com/yourprofile`}
                style={{ width: '100%', fontSize: '0.8rem', padding: '0.4rem' }}
              />
            )}
          </div>
        )
      })}

      <h4 style={{ margin: '0.5rem 0 0', fontSize: '0.9rem', fontWeight: '600' }}>Icon Style</h4>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Style
        </label>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {['colored', 'dark', 'light'].map(style => (
            <button
              key={style}
              onClick={() => onUpdate({ iconStyle: style })}
              style={{
                flex: 1,
                padding: '0.5rem',
                border: settings.iconStyle === style ? '2px solid var(--color-primary)' : '1px solid #e5e7eb',
                borderRadius: '6px',
                background: settings.iconStyle === style ? 'rgba(99, 102, 241, 0.08)' : '#fff',
                color: settings.iconStyle === style ? 'var(--color-primary)' : '#64748b',
                fontWeight: settings.iconStyle === style ? '600' : '400',
                fontSize: '0.75rem',
                cursor: 'pointer',
                textTransform: 'capitalize'
              }}
            >
              {style}
            </button>
          ))}
        </div>
      </div>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Icon Size: {settings.iconSize || 32}px
        </label>
        <input
          type="range"
          min="20"
          max="64"
          step="4"
          value={parseInt(settings.iconSize) || 32}
          onChange={(e) => onUpdate({ iconSize: e.target.value })}
          style={{ width: '100%', cursor: 'pointer' }}
        />
      </div>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Spacing: {settings.iconSpacing || 8}px
        </label>
        <input
          type="range"
          min="0"
          max="24"
          step="2"
          value={parseInt(settings.iconSpacing) || 8}
          onChange={(e) => onUpdate({ iconSpacing: e.target.value })}
          style={{ width: '100%', cursor: 'pointer' }}
        />
      </div>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Shape
        </label>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {[
            { value: '50%', label: 'Circle' },
            { value: '8px', label: 'Rounded' },
            { value: '0px', label: 'Square' }
          ].map(shape => (
            <button
              key={shape.value}
              onClick={() => onUpdate({ iconRadius: shape.value })}
              style={{
                flex: 1,
                padding: '0.5rem',
                border: settings.iconRadius === shape.value ? '2px solid var(--color-primary)' : '1px solid #e5e7eb',
                borderRadius: '6px',
                background: settings.iconRadius === shape.value ? 'rgba(99, 102, 241, 0.08)' : '#fff',
                color: settings.iconRadius === shape.value ? 'var(--color-primary)' : '#64748b',
                fontWeight: settings.iconRadius === shape.value ? '600' : '400',
                fontSize: '0.75rem',
                cursor: 'pointer'
              }}
            >
              {shape.label}
            </button>
          ))}
        </div>
      </div>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Alignment
        </label>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {['left', 'center', 'right'].map(align => (
            <button
              key={align}
              onClick={() => onUpdate({ textAlign: align })}
              style={{
                flex: 1,
                padding: '0.5rem',
                border: settings.textAlign === align ? '2px solid var(--color-primary)' : '1px solid #e5e7eb',
                borderRadius: '6px',
                background: settings.textAlign === align ? 'rgba(99, 102, 241, 0.08)' : '#fff',
                color: settings.textAlign === align ? 'var(--color-primary)' : '#64748b',
                fontWeight: settings.textAlign === align ? '600' : '400',
                fontSize: '0.8rem',
                cursor: 'pointer',
                textTransform: 'capitalize'
              }}
            >
              {align}
            </button>
          ))}
        </div>
      </div>

      <CommonSettings settings={settings} onUpdate={onUpdate} />
    </div>
  )
}
